import { getLocale, setLocale, locales as localesOrig, localStorageKey } from "@repo/localization/runtime";

const raw = getLocale();
let l = $state(raw === "de" ? "de-DE" : raw === "en" ? "en-GB" : raw);

export type Locale = typeof l;

export const locale = {
    get current() {
        return l;
    },
    set current(x: Locale) {
        setLocale(x, { reload: false });
        l = x;
    },
};

export const locales = localesOrig.filter(x => x.includes("-"));

window.addEventListener("storage", e => {
    if (e.key === localStorageKey && e.newValue) {
        locale.current = e.newValue as Locale;
    }
});
